"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var Rx_1 = require("rxjs/Rx");
var BhtpLicenseService = (function (_super) {
    __extends(BhtpLicenseService, _super);
    function BhtpLicenseService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.agreementCache = {};
        _this.licenseCache = {};
        return _this;
    }
    BhtpLicenseService.prototype.getAgreements = function (agentCode) {
        var _this = this;
        // check for cached value and return that
        if (this.agreementCache[agentCode]) {
            return Rx_1.Observable.of(this.agreementCache[agentCode]);
        }
        var url = this.getFullUrl("/v1/Licenses/Agreements/" + agentCode);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.get(url, options)
            .map(function (res) { return res.json(); })
            .do(function (val) {
            _this.agreementCache[agentCode] = val;
        })
            .catch(this.handleError);
    };
    BhtpLicenseService.prototype.getLicenses = function (agentCode) {
        var _this = this;
        // check for cached value and return that
        if (this.licenseCache[agentCode]) {
            return Rx_1.Observable.of(this.licenseCache[agentCode]);
        }
        var url = this.getFullUrl("/v1/Licenses/" + agentCode);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.get(url, options)
            .map(function (res) { return res.json(); })
            .do(function (val) {
            _this.licenseCache[agentCode] = val;
        })
            .catch(this.handleError);
    };
    return BhtpLicenseService;
}(base_1.BhtpBaseService));
BhtpLicenseService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpLicenseService);
exports.BhtpLicenseService = BhtpLicenseService;
//# sourceMappingURL=D:/a/1/s/purchase/src/license.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/license.service.js